import moment from 'moment'

/** Поля заказа, нужные для типа доставки */
export type OrderDeliveryFields = {
  delivery_type?: boolean | null
  in_time?: Date | string | null
}

/** Подписи типа получения и назначенного времени */
export type OrderDeliveryInfo = {
  typeLabel: 'Доставка' | 'Самовывоз'
  scheduledTimeLabel: string | null
}

/**
 * Тип получения и время «ко времени» для карточки / таблицы.
 * @param order — заказ с delivery_type и in_time
 */
export const formatOrderDeliveryInfo = (
  order: OrderDeliveryFields | null | undefined
): OrderDeliveryInfo => {
  const typeLabel = order?.delivery_type ? 'Доставка' : 'Самовывоз'
  if (!order?.delivery_type || order?.in_time == null) {
    return { typeLabel, scheduledTimeLabel: null }
  }

  const scheduledMoment = moment(order.in_time)
  if (!scheduledMoment.isValid()) {
    return { typeLabel, scheduledTimeLabel: null }
  }

  return {
    typeLabel,
    scheduledTimeLabel: `${scheduledMoment.format('L')} - ${scheduledMoment.format('LT')}`,
  }
}
